import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import BatchSearchProgressModalContent from './Components/BatchSearchProgressModalContent';
import BatchSearchProgressModalFooter from './Components/BatchSearchProgressModalFooter';

import './BatchSearchProgressModal.custom.scss';
import './BatchSearchProgressModal.theme.scss';

function BatchSearchProgressModal(props) {
  const { init, cancelSearch, destroy } = props;
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="react-dialogs-backdrop" />
      <GeneralDialogLayout
        {...props}
        className="batch-search-modal"
        size="sm"
        closeBtn={false}
        headerClassName="rx-border-none"
        footerClassName="rx-border-none"
        footer={<BatchSearchProgressModalFooter cancelSearch={cancelSearch} />}>
        <BatchSearchProgressModalContent {...props} />
      </GeneralDialogLayout>
    </>
  );
}

BatchSearchProgressModal.propTypes = {
  init: PropTypes.func.isRequired,
  cancelSearch: PropTypes.func.isRequired,
  destroy: PropTypes.func.isRequired,
};

export default BatchSearchProgressModal;
